import { render, staticRenderFns } from "./index_v2.vue?vue&type=template&id=08787a2e&"
import script from "./index_v2.vue?vue&type=script&lang=js&"
export * from "./index_v2.vue?vue&type=script&lang=js&"
import style0 from "./index_v2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports